import { IconProps } from "@/src/sb/business-layer/types"

const AngleDown = (props: IconProps) => (
  <svg
    width={props.width ?? props.size ?? 16}
    height={props.height ?? props.size ?? 16}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.2093 5.82299L9.05001 9.98233L8.78401 10.2483C8.6796 10.3527 8.53479 10.3921 8.3999 10.3665C8.26501 10.3921 8.12019 10.3527 8.01578 10.2483L7.74978 9.98233L3.59044 5.82299L3.32444 5.55699C3.15681 5.38936 3.15681 5.11757 3.32444 4.94994C3.49207 4.78231 3.76386 4.78231 3.93149 4.94994L4.19749 5.21594L8.35683 9.37528L8.3999 9.41835L8.44297 9.37528L12.6023 5.21594L12.8683 4.94994C13.0359 4.78231 13.3077 4.78231 13.4754 4.94994C13.643 5.11757 13.643 5.38936 13.4754 5.55699L13.2093 5.82299Z"
      fill="currentColor"
    />
  </svg>
)

export default AngleDown
